<template>
  <div ref="root">
    <div class="target" :class="{ 'is-show': isShow }">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.target {
  transition: all 400ms ease-in-out;
  opacity: 0;
  transform: translate3d(0, 10%, 0);
  &.is-show {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<script>
export default {
  name: 'FadeIn',
  props: {
    delay: {
      type: Number,
      default: 100
    },
    margin: {
      type: String,
      default: '40%'
    },
  },
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.start()
            observer.disconnect()
          }
        })
      },
      {
        root: null,
        rootMargin: `0px 0px -${this.margin} 0px`,
        threshold: 0
      })
    observer.observe(this.$refs.root)
  },
  methods: {
    start() {
      setTimeout(() => {
        this.isShow = true
      }, this.delay)
    }
  }
}
</script>